export const validate = (e, conditions, cb) => {
  e.preventDefault();
  for (let cond of conditions) {
    if (cond.statement()) {
      alert(cond.text);
      return;
    }
  }
  cb();
}